<template>
  <v-layout lp-header>
    <picture>
      <source srcset="/img/logo_color.webp" type="image/webp" />
      <source srcset="/img/logo_color.png" type="image/png" />
      <img src="/img/logo_color.png" alt="[Logo]" class="logo-img" />
    </picture>
    <v-spacer></v-spacer>
  </v-layout>
</template>

<script>
export default {
  props: { hideDownloads: { type: Boolean, default: () => false } },
};
</script>

<style scoped>
.lp-header {
  position: fixed;
  z-index: 3;
  top: 0;
  width: 100vw;
  height: 50px;
  background-color: white;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.5);
}
.logo-img {
  width: 100px;
  height: 28px;
  margin-top: 10px;
  margin-left: 15px;
}
.text-btn-sm {
  font-weight: bold;
  font-size: 16px;
  line-height: 1em;
  margin-top: 2px;
}
.text-btn {
  font-weight: bold;
  font-size: 30px;
}
@media (max-width: 767px) {
  .lp-header {
    height: 35px;
  }
  .logo-img {
    margin-top: 7.5px;
    width: 65px;
    height: 18px;
  }
  .text-btn-sm {
    font-size: 10px;
  }
  .text-btn {
    font-size: 18px;
  }
}
</style>
